const WalletLogo = () => {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width='95%' height='100%' viewBox='0 0 40 42' fill='none'>
			<path
				d='M17.468 1.27408C18.8293 0.488092 20.5066 0.488093 21.868 1.27408L35.6545 9.23374C37.0159 10.0197 37.8545 11.4723 37.8545 13.0442V28.9636C37.8545 30.5355 37.0159 31.9881 35.6545 32.7741L21.868 40.7337C20.5066 41.5197 18.8293 41.5197 17.468 40.7337L3.68143 32.7741C2.32007 31.9881 1.48144 30.5355 1.48144 28.9636V13.0442C1.48144 11.4723 2.32007 10.0197 3.68144 9.23374L17.468 1.27408Z'
				fill='#0064C5'
			/>
			<path
				d='M17.7178 1.70703C18.9244 1.01036 20.4115 1.01036 21.6182 1.70703L35.4043 9.66699C36.6109 10.3636 37.3544 11.6507 37.3545 13.0439V28.9639C37.3544 30.3571 36.6109 31.6442 35.4043 32.3408L21.6182 40.3008C20.4115 40.9974 18.9244 40.9974 17.7178 40.3008L3.93164 32.3408C2.72506 31.6442 1.98155 30.3571 1.98145 28.9639V13.0439C1.98155 11.6507 2.72506 10.3636 3.93164 9.66699L17.7178 1.70703Z'
				stroke='url(#paint0_linear_4027_9620)'
				strokeOpacity='0.09'
			/>
			<g style={{ mixBlendMode: 'overlay' }} opacity='0.72' filter='url(#filter0_i_4027_9620)'>
				<path
					d='M17.468 1.27408C18.8293 0.488092 20.5066 0.488093 21.868 1.27408L35.6545 9.23374C37.0159 10.0197 37.8545 11.4723 37.8545 13.0442V28.9636C37.8545 30.5355 37.0159 31.9881 35.6545 32.7741L21.868 40.7337C20.5066 41.5197 18.8293 41.5197 17.468 40.7337L3.68143 32.7741C2.32007 31.9881 1.48144 30.5355 1.48144 28.9636V13.0442C1.48144 11.4723 2.32007 10.0197 3.68144 9.23374L17.468 1.27408Z'
					fill='white'
					fillOpacity='0.01'
				/>
			</g>
			<mask
				id='mask0_4027_9620'
				style={{ maskType: 'alpha' }}
				maskUnits='userSpaceOnUse'
				x='1'
				y='0'
				width='36'
				height='41'
			>
				<path
					d='M17.0422 1.02017C18.4036 0.234186 20.0808 0.234186 21.4422 1.02017L34.7957 8.72983C36.1571 9.51581 36.9957 10.9684 36.9957 12.5403V27.9597C36.9957 29.5316 36.1571 30.9842 34.7957 31.7702L21.4422 39.4798C20.0808 40.2658 18.4036 40.2658 17.0422 39.4798L3.68867 31.7702C2.3273 30.9842 1.48867 29.5316 1.48867 27.9597V12.5403C1.48867 10.9684 2.3273 9.51581 3.68867 8.72983L17.0422 1.02017Z'
					fill='url(#paint1_linear_4027_9620)'
				/>
				<path
					d='M17.292 1.45312C18.4987 0.756457 19.9857 0.756457 21.1924 1.45312L34.5459 9.16309C35.7523 9.85974 36.496 11.1469 36.4961 12.54V27.96C36.496 29.3531 35.7523 30.6403 34.5459 31.3369L21.1924 39.0469C19.9857 39.7435 18.4987 39.7435 17.292 39.0469L3.93848 31.3369C2.73205 30.6403 1.98839 29.3531 1.98828 27.96V12.54C1.98839 11.1469 2.73205 9.85974 3.93848 9.16309L17.292 1.45312Z'
					stroke='url(#paint2_linear_4027_9620)'
					strokeOpacity='0.24'
				/>
			</mask>
			<g mask='url(#mask0_4027_9620)'>
				<g filter='url(#filter1_f_4027_9620)'>
					<path
						d='M24.168 7.89873C31.4256 12.5644 32.472 19.4428 32.088 22.2988C34.968 18.8428 34.776 13.8988 34.32 11.8588C33.6924 9.05074 27.912 5.65231 24.168 7.89873Z'
						fill='white'
						fillOpacity='0.32'
					/>
				</g>
				<g filter='url(#filter2_f_4027_9620)'>
					<path
						d='M14.168 32.2556C6.91032 27.5899 5.86391 20.7115 6.24791 17.8555C3.36789 21.3115 3.5599 26.2555 4.0159 28.2955C4.64357 31.1036 10.4239 34.502 14.168 32.2556Z'
						fill='white'
						fillOpacity='0.24'
					/>
				</g>
				<path
					d='M-26.4238 -27.0273H69.0488L40.8246 6.70489L27.3605 40.4371H11.7364L-0.0716457 6.70489L-26.4238 -27.0273Z'
					fill='url(#paint3_linear_4027_9620)'
					fillOpacity='0.2'
				/>
				<path
					d='M17.7834 38.9275L8.2793 -14.7129H28.4394L23.0394 38.9275H17.7834Z'
					fill='url(#paint4_linear_4027_9620)'
					fillOpacity='0.2'
				/>
				<path
					d='M41.3289 -14.7129L25.6328 37.3435H30.1688L59.545 -14.7129H41.3289Z'
					fill='url(#paint5_linear_4027_9620)'
					fillOpacity='0.2'
				/>
				<path
					d='M-1.2254 -14.7129L14.4707 37.3435H9.93467L-19.4415 -14.7129H-1.2254Z'
					fill='url(#paint6_linear_4027_9620)'
					fillOpacity='0.2'
				/>
				<mask
					id='mask1_4027_9620'
					style={{ maskType: 'alpha' }}
					maskUnits='userSpaceOnUse'
					x='-8'
					y='-15'
					width='56'
					height='56'
				>
					<rect x='-7.3418' y='-14.7129' width='54.7204' height='54.7204' fill='url(#paint7_radial_4027_9620)' />
				</mask>
				<g mask='url(#mask1_4027_9620)'>
					<g clipPath='url(#clip0_4027_9620)'>
						<path
							d='M31.065 20.6508C31.2101 20.3275 30.8984 20.015 30.5759 20.1604C30.5061 20.1928 30.4523 20.2467 30.4201 20.3167C30.2696 20.64 30.5867 20.9525 30.9091 20.807C30.979 20.7747 31.0327 20.7208 31.065 20.6508Z'
							fill='white'
							fillOpacity='0.32'
						/>
						<path
							d='M26.4595 4.24454C26.6046 3.92123 26.2929 3.60871 25.9705 3.75419C25.9006 3.78652 25.8469 3.84041 25.8146 3.91046C25.6641 4.23376 25.9812 4.54629 26.3036 4.4008C26.3735 4.36847 26.4272 4.31459 26.4595 4.24454Z'
							fill='white'
							fillOpacity='0.32'
						/>
						<path
							d='M6.70949 28.6879C6.85459 28.3646 6.5429 28.0521 6.22046 28.1976C6.1506 28.2299 6.09685 28.2838 6.06461 28.3538C5.91414 28.6771 6.2312 28.9896 6.55364 28.8442C6.6235 28.8118 6.67725 28.7579 6.70949 28.6879Z'
							fill='white'
							fillOpacity='0.32'
						/>
						<path
							d='M26.7427 33.473C26.8878 33.1497 26.5761 32.8372 26.2537 32.9827C26.1838 33.015 26.1301 33.0689 26.0978 33.139C25.9473 33.4623 26.2644 33.7748 26.5869 33.6293C26.6567 33.597 26.7105 33.5431 26.7427 33.473Z'
							fill='white'
							fillOpacity='0.64'
						/>
						<path
							d='M5.56105 34.0785C5.70615 33.7552 5.39446 33.4427 5.07202 33.5882C5.00216 33.6205 4.94842 33.6744 4.91617 33.7444C4.7657 34.0677 5.08277 34.3803 5.40521 34.2348C5.47507 34.2025 5.52881 34.1486 5.56105 34.0785Z'
							fill='white'
							fillOpacity='0.64'
						/>
						<path
							d='M25.2055 12.5453C25.351 12.222 25.0384 11.9095 24.7151 12.055C24.6451 12.0873 24.5912 12.1412 24.5589 12.2112C24.4134 12.5345 24.7259 12.8471 25.0492 12.7016C25.1193 12.6693 25.1732 12.6154 25.2055 12.5453Z'
							fill='white'
							fillOpacity='0.32'
						/>
						<path
							d='M20.3656 6.7836C20.5111 6.4603 20.1986 6.14777 19.8753 6.29326C19.8053 6.32559 19.7514 6.37947 19.719 6.44952C19.5736 6.77282 19.8861 7.08535 20.2094 6.93986C20.2794 6.90753 20.3333 6.85365 20.3656 6.7836Z'
							fill='white'
							fillOpacity='0.64'
						/>
						<path
							d='M7.2173 17.8578C7.3624 17.5345 7.05071 17.222 6.72826 17.3675C6.6584 17.3998 6.60467 17.4537 6.57242 17.5237C6.42195 17.847 6.73902 18.1596 7.06147 18.0141C7.13133 17.9818 7.18506 17.9279 7.2173 17.8578Z'
							fill='white'
							fillOpacity='0.32'
						/>
						<path
							d='M21.0569 9.2836C20.9114 8.9603 21.224 8.64777 21.5473 8.79326C21.6173 8.82559 21.6712 8.87947 21.7035 8.94952C21.849 9.27282 21.5365 9.58535 21.2132 9.43986C21.1431 9.40753 21.0893 9.35365 21.0569 9.2836Z'
							fill='white'
							fillOpacity='0.32'
						/>
						<path
							d='M12.5607 36.7836C12.4156 36.4603 12.7273 36.1478 13.0498 36.2933C13.1196 36.3256 13.1734 36.3795 13.2056 36.4495C13.3561 36.7728 13.039 37.0853 12.7166 36.9399C12.6467 36.9075 12.593 36.8536 12.5607 36.7836Z'
							fill='white'
							fillOpacity='0.32'
						/>
						<path
							d='M6.49628 24.4106C6.35118 24.0872 6.66288 23.7747 6.98533 23.9202C7.05519 23.9525 7.10892 24.0064 7.14116 24.0765C7.29164 24.3998 6.97458 24.7123 6.65214 24.5668C6.58227 24.5345 6.52853 24.4806 6.49628 24.4106Z'
							fill='white'
							fillOpacity='0.32'
						/>
						<path
							d='M8.69941 16.7836C8.55431 16.4603 8.86599 16.1478 9.18844 16.2933C9.2583 16.3256 9.31205 16.3795 9.34429 16.4495C9.49476 16.7728 9.17769 17.0853 8.85525 16.9399C8.78538 16.9075 8.73166 16.8536 8.69941 16.7836Z'
							fill='white'
							fillOpacity='0.32'
						/>
						<path
							d='M24.2991 37.3305C24.1536 37.0072 24.4662 36.6946 24.7895 36.8401C24.8595 36.8725 24.9134 36.9263 24.9457 36.9964C25.0912 37.3197 24.7787 37.6322 24.4554 37.4867C24.3853 37.4544 24.3314 37.4005 24.2991 37.3305Z'
							fill='white'
							fillOpacity='0.32'
						/>
						<path
							d='M31.7876 14.2445C31.9327 13.9212 31.621 13.6087 31.2986 13.7542C31.2287 13.7865 31.175 13.8404 31.1427 13.9105C30.9923 14.2338 31.3093 14.5463 31.6318 14.4008C31.7016 14.3685 31.7554 14.3146 31.7876 14.2445Z'
							fill='white'
							fillOpacity='0.32'
						/>
						<path
							d='M37.6002 9.94767C37.7506 9.62436 37.4336 9.31183 37.1111 9.45732C37.0413 9.48965 36.9875 9.54354 36.9553 9.61359C36.8102 9.93689 37.1219 10.2494 37.4443 10.1039C37.5142 10.0716 37.5679 10.0177 37.6002 9.94767Z'
							fill='white'
							fillOpacity='0.32'
						/>
						<path
							d='M32.8831 7.17422C32.7376 6.85092 33.0501 6.5384 33.3734 6.68388C33.4435 6.71621 33.4974 6.77009 33.5297 6.84014C33.6752 7.16345 33.3627 7.47597 33.0394 7.33049C32.9693 7.29816 32.9154 7.24427 32.8831 7.17422Z'
							fill='white'
							fillOpacity='0.32'
						/>
						<path
							d='M34.8791 17.3388C34.734 17.0164 35.0457 16.7047 35.3681 16.8498C35.438 16.882 35.4917 16.9358 35.524 17.0056C35.6745 17.3281 35.3574 17.6452 35.0349 17.4947C34.9651 17.4624 34.9113 17.4087 34.8791 17.3388Z'
							fill='white'
							fillOpacity='0.32'
						/>
						<path
							d='M1.90836 20.3578C1.75789 20.0345 2.07495 19.722 2.39739 19.8675C2.46726 19.8998 2.521 19.9537 2.55324 20.0237C2.69834 20.347 2.38665 20.6596 2.0642 20.5141C1.99434 20.4818 1.9406 20.4279 1.90836 20.3578Z'
							fill='white'
							fillOpacity='0.32'
						/>
						<path
							d='M30.8537 36.0609C30.7032 35.7376 31.0203 35.4251 31.3427 35.5706C31.4126 35.6029 31.4663 35.6568 31.4986 35.7269C31.6437 36.0502 31.332 36.3627 31.0095 36.2172C30.9397 36.1849 30.8859 36.131 30.8537 36.0609Z'
							fill='white'
							fillOpacity='0.32'
						/>
						<path
							d='M14.0275 24.5668C13.877 24.2435 14.1941 23.931 14.5165 24.0765C14.5864 24.1088 14.6401 24.1627 14.6724 24.2327C14.8175 24.556 14.5058 24.8686 14.1834 24.7231C14.1135 24.6907 14.0597 24.6369 14.0275 24.5668Z'
							fill='white'
							fillOpacity='0.32'
						/>
						<path
							d='M30.6877 24.2641C30.5372 23.9408 30.8543 23.6282 31.1767 23.7737C31.2466 23.8061 31.3003 23.8599 31.3325 23.93C31.4776 24.2533 31.1659 24.5658 30.8435 24.4203C30.7736 24.388 30.7199 24.3341 30.6877 24.2641Z'
							fill='white'
							fillOpacity='0.32'
						/>
						<path
							d='M20.9886 32.9555C20.8431 32.6322 21.1556 32.3196 21.4789 32.4651C21.549 32.4975 21.6028 32.5513 21.6352 32.6214C21.7807 32.9447 21.4681 33.2572 21.1448 33.1117C21.0748 33.0794 21.0209 33.0255 20.9886 32.9555Z'
							fill='white'
							fillOpacity='0.32'
						/>
					</g>
				</g>
			</g>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M20.1883 9.41952C20.6102 9.42636 20.849 9.88518 20.6381 10.2506L12.9295 23.6022C12.8261 23.7813 12.635 23.8917 12.4282 23.8917H9.23156C8.9674 23.8917 8.73521 23.7132 8.6794 23.455C8.50815 22.6627 8.41797 21.8404 8.41797 20.9969C8.41797 14.602 13.602 9.41797 19.9969 9.41797C20.0608 9.41797 20.1246 9.41848 20.1883 9.41952ZM23.3351 9.90644C23.0859 9.83151 22.8208 9.9438 22.6906 10.1692L21.1308 12.8709C21.0274 13.05 21.0274 13.2707 21.1308 13.4498L28.9469 26.9879C29.157 27.3516 29.6707 27.3762 29.8894 27.0176C30.9593 25.2633 31.5758 23.2021 31.5758 20.9969C31.5758 15.7626 28.1026 11.3395 23.3351 9.90644ZM27.8816 29.4765C28.0731 29.2983 28.1095 29.0111 27.9787 28.7845L26.3237 25.918C26.2203 25.7388 26.0292 25.6285 25.8224 25.6285H10.2662C9.8488 25.6285 9.57053 26.0564 9.76647 26.425C11.712 30.0842 15.5635 32.5759 19.9969 32.5759C23.043 32.5759 25.8144 31.3996 27.8816 29.4765ZM19.4595 15.7656C19.6823 15.3796 20.2394 15.3796 20.4622 15.7656L24.6525 23.0232C24.8753 23.4092 24.5967 23.8917 24.1511 23.8917H15.7707C15.325 23.8917 15.0465 23.4092 15.2693 23.0232L19.4595 15.7656Z'
				fill='white'
			/>
			<path
				d='M20 7.7793C27.3018 7.77932 33.2207 13.6982 33.2207 21C33.2207 28.3018 27.3018 34.2207 20 34.2207C12.6982 34.2207 6.7793 28.3018 6.7793 21C6.7793 13.6982 12.6982 7.7793 20 7.7793Z'
				stroke='white'
				strokeWidth='1.05769'
			/>
			<defs>
				<filter
					id='filter0_i_4027_9620'
					x='1.48047'
					y='0.68457'
					width='36.375'
					height='40.6387'
					filterUnits='userSpaceOnUse'
					colorInterpolationFilters='sRGB'
				>
					<feFlood floodOpacity='0' result='BackgroundImageFix' />
					<feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
					<feColorMatrix
						in='SourceAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						result='hardAlpha'
					/>
					<feOffset />
					<feGaussianBlur stdDeviation='1.6' />
					<feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
					<feColorMatrix type='matrix' values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0' />
					<feBlend mode='normal' in2='shape' result='effect1_innerShadow_4027_9620' />
				</filter>
				<filter
					id='filter1_f_4027_9620'
					x='21.6336'
					y='4.63416'
					width='15.4848'
					height='20.1991'
					filterUnits='userSpaceOnUse'
					colorInterpolationFilters='sRGB'
				>
					<feFlood floodOpacity='0' result='BackgroundImageFix' />
					<feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
					<feGaussianBlur stdDeviation='1.26721' result='effect1_foregroundBlur_4027_9620' />
				</filter>
				<filter
					id='filter2_f_4027_9620'
					x='1.21754'
					y='15.3211'
					width='15.4848'
					height='20.1991'
					filterUnits='userSpaceOnUse'
					colorInterpolationFilters='sRGB'
				>
					<feFlood floodOpacity='0' result='BackgroundImageFix' />
					<feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
					<feGaussianBlur stdDeviation='1.26721' result='effect1_foregroundBlur_4027_9620' />
				</filter>
				<linearGradient
					id='paint0_linear_4027_9620'
					x1='19.668'
					y1='0.00390625'
					x2='19.668'
					y2='42.0039'
					gradientUnits='userSpaceOnUse'
				>
					<stop stopColor='white' />
					<stop offset='1' stopColor='white' stopOpacity='0' />
				</linearGradient>
				<linearGradient
					id='paint1_linear_4027_9620'
					x1='18.2745'
					y1='-0.387998'
					x2='18.2745'
					y2='52.367'
					gradientUnits='userSpaceOnUse'
				>
					<stop stopColor='#F3B22F' />
					<stop offset='1' stopColor='#FFD774' />
				</linearGradient>
				<linearGradient
					id='paint2_linear_4027_9620'
					x1='19.2422'
					y1='-0.25'
					x2='19.2422'
					y2='40.75'
					gradientUnits='userSpaceOnUse'
				>
					<stop stopColor='white' />
					<stop offset='1' stopColor='white' stopOpacity='0' />
				</linearGradient>
				<linearGradient
					id='paint3_linear_4027_9620'
					x1='13.3924'
					y1='40.4371'
					x2='13.3924'
					y2='22.797'
					gradientUnits='userSpaceOnUse'
				>
					<stop stopColor='white' />
					<stop offset='1' stopColor='white' stopOpacity='0' />
				</linearGradient>
				<linearGradient
					id='paint4_linear_4027_9620'
					x1='18.3594'
					y1='-14.7129'
					x2='18.3594'
					y2='38.9275'
					gradientUnits='userSpaceOnUse'
				>
					<stop stopColor='white' />
					<stop offset='1' stopColor='white' stopOpacity='0' />
				</linearGradient>
				<linearGradient
					id='paint5_linear_4027_9620'
					x1='42.5889'
					y1='-14.7129'
					x2='42.5889'
					y2='37.3435'
					gradientUnits='userSpaceOnUse'
				>
					<stop stopColor='white' />
					<stop offset='1' stopColor='white' stopOpacity='0' />
				</linearGradient>
				<linearGradient
					id='paint6_linear_4027_9620'
					x1='-2.48541'
					y1='-14.7129'
					x2='-2.48541'
					y2='37.3435'
					gradientUnits='userSpaceOnUse'
				>
					<stop stopColor='white' />
					<stop offset='1' stopColor='white' stopOpacity='0' />
				</linearGradient>
				<radialGradient
					id='paint7_radial_4027_9620'
					cx='0'
					cy='0'
					r='1'
					gradientUnits='userSpaceOnUse'
					gradientTransform='translate(20.0184 36.1915) rotate(-105.98) scale(32.4294)'
				>
					<stop stopColor='white' />
					<stop offset='1' stopColor='white' stopOpacity='0' />
				</radialGradient>
				<clipPath id='clip0_4027_9620'>
					<rect width='54.8644' height='54.1444' fill='white' transform='translate(-7.48828 -14.7129)' />
				</clipPath>
			</defs>
		</svg>
	);
};

export default WalletLogo;
